import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

export const IfBrowser = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
  const [isBrowser, setIsBrowser] = useState(false);

  // useEffect does not run server-side
  // https://codewithhugo.com/react-useeffect-ssr/#:~:text=When%20does%20useEffect%20run%3F
  useEffect(() => setIsBrowser(true), []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isBrowser ? <>{children}</> : null;
};
